import { Action } from 'store/store';
import { StreamError } from 'streamsState/store/streamStatuses/StreamErrorState';
import { SymbolTilesMessage } from 'communication/types/symbolTiles/SymbolTilesElement';

export enum SymbolTilesStreamActionType {
    CLEAR_SYMBOL_TILES_STREAM = 'CLEAR_SYMBOL_TILES_STREAM',
    REMOVE_SYMBOL_TILES_STREAM = 'REMOVE_SYMBOL_TILES_STREAM',
    WATCH_SYMBOL_TILES_STREAM = 'WATCH_SYMBOL_TILES_STREAM',
    HANDLE_SYMBOL_TILES_STREAM_ERROR = 'HANDLE_SYMBOL_TILES_STREAM_ERROR',
    HANDLE_SYMBOL_TILES_STREAM_MESSAGE_BATCH = 'HANDLE_SYMBOL_TILES_STREAM_MESSAGE_BATCH',
}

export type ClearSymbolTilesStreamAction =
    Action<SymbolTilesStreamActionType.CLEAR_SYMBOL_TILES_STREAM>;

export const clearSymbolTilesStream = (): ClearSymbolTilesStreamAction => ({
    type: SymbolTilesStreamActionType.CLEAR_SYMBOL_TILES_STREAM,
});

export type WatchSymbolTilesStreamAction = Action<
    SymbolTilesStreamActionType.WATCH_SYMBOL_TILES_STREAM,
    { streamKey: string }
>;

export const watchSymbolTilesStream: (
    streamKey: string
) => WatchSymbolTilesStreamAction = (streamKey) => ({
    type: SymbolTilesStreamActionType.WATCH_SYMBOL_TILES_STREAM,
    payload: { streamKey },
});

export type HandleSymbolTilesStreamErrorAction = Action<
    SymbolTilesStreamActionType.HANDLE_SYMBOL_TILES_STREAM_ERROR,
    {
        error: StreamError;
    }
>;

export const handleSymbolTilesStreamError: (
    error: StreamError
) => HandleSymbolTilesStreamErrorAction = (error) => ({
    type: SymbolTilesStreamActionType.HANDLE_SYMBOL_TILES_STREAM_ERROR,
    payload: { error },
});

export type HandleSymbolTilesStreamMessageBatchAction = Action<
    SymbolTilesStreamActionType.HANDLE_SYMBOL_TILES_STREAM_MESSAGE_BATCH,
    {
        messages: SymbolTilesMessage[];
    }
>;

export const handleSymbolTilesStreamMessageBatch: (
    messages: SymbolTilesMessage[]
) => HandleSymbolTilesStreamMessageBatchAction = (messages) => ({
    type: SymbolTilesStreamActionType.HANDLE_SYMBOL_TILES_STREAM_MESSAGE_BATCH,
    payload: { messages },
});

export type RemoveSymbolTilesStreamAction = Action<
    SymbolTilesStreamActionType.REMOVE_SYMBOL_TILES_STREAM,
    {
        symbol: string;
    }
>;

export const createRemoveSymbolTilesStreamAction: (
    symbol: string
) => RemoveSymbolTilesStreamAction = (symbol) => ({
    type: SymbolTilesStreamActionType.REMOVE_SYMBOL_TILES_STREAM,
    payload: { symbol },
});

export type SymbolTilesStreamAction =
    | ClearSymbolTilesStreamAction
    | RemoveSymbolTilesStreamAction
    | WatchSymbolTilesStreamAction
    | HandleSymbolTilesStreamErrorAction
    | HandleSymbolTilesStreamMessageBatchAction;
